import { z } from 'zod'

export const s3ObjectResourceTypeSchema = z.enum([
  'millsheets',
  'deliveryNotes',
  'deliveryNoteDocuments',
  'millsheetSteelScanLog',
  'metalTag',
  'documentSample',
  'document',
  'ocrDatasetSample',
])
export type S3ObjectResourceType = z.infer<typeof s3ObjectResourceTypeSchema>

export const s3ObjectResourceTypeLabels = {
  millsheets: 'ミルシートPDF',
  deliveryNotes: '納品書PDF',
  deliveryNoteDocuments: '納品書PDF',
  millsheetSteelScanLog: 'スキャンログ画像',
  metalTag: 'メタルタグ画像',
  documentSample: '帳票サンプル画像',
  document: '帳票PDF',
  ocrDatasetSample: 'OCRデータセット',
}
